/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AppContext } from "@/App";
import Loading from "@/Components/loading";

function ProtectedRoute() {
    const app = useContext(AppContext);

    const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
       const [loading, setLoading] = useState<boolean>(true); // add a loading state
        useEffect(() => {
            // Get the cookie value
            let retryCount = 0; // initialize the retry count
            const maxRetries = 5; // set the maximum number of retries
            const delay: number = 0; // set the delay in milliseconds
    
            // define a delay function that returns a promise
            function wait(delay: number) {
                return new Promise((resolve) => setTimeout(resolve, delay));
            }
    
            // define a fetch function that retries until status 200 or 401
            async function fetchWithRetry(url: string, options: any) {
                try {
                    // make the fetch request
                    const response = await fetch(url, options);
    
                    // check the status code
                    if (response.status == 200) {
                        const j: any = await response.json();
                        app.setApplicationUser({ id: j.id, email: j.email, name: j.name, role: j.role, projectUserRoles: j.projectUserRoles });
                        setIsLoggedIn(true);
                        return response; // return the response
                    } else if (response.status == 401) {
                        console.log("Unauthorized");
                        return response; // return the response
                    } else {
                        // throw an error to trigger the catch block
                        throw new Error("" + response.status);
                    }
                } catch (error) {
                    // increment the retry count
                    retryCount++;
                    // check if the retry limit is reached
                    if (retryCount > maxRetries) {
                        // stop retrying and rethrow the error
                        throw error;
                    } else {
                        // wait for some time and retry
                        await wait(delay);
                        return fetchWithRetry(url, options);
                    }
                }
            }
    
            // call the fetch function with retry logic
            fetchWithRetry("/pingauth", {
                method: "GET",
            })
                .catch((error) => {
                    // handle the final error
                    console.log(error.message);
                })
                .finally(() => {
                         setLoading(false);  // set loading to false when the fetch is done
                });
    
        }, []);

        if(loading) {
            return <Loading />;
        }

    return isLoggedIn === true ? <Outlet /> : <Navigate to="/login" />;
}

export default ProtectedRoute;